import { observable, action, makeObservable, autorun } from 'mobx';
import productStore from './store.product';
import { getDefaultParams } from './default_params';
import { deepCopy } from '@/utils';

/**
 * 当前型号的默认值
 */
export let CUR_DEFAULTS: ConfigParams = {};

class ParamsStore {
  constructor() {
    makeObservable(this);
  }

  /**
   * 配置管理
   */
  @observable
  settings: ConfigSettings = {};

  @action.bound
  updateSettings(payload: ConfigSettings = {}) {
    this.settings = { ...this.settings, ...payload };
  }

  /**
   * 联系人
   */
  @observable
  phonebook: ConfigPhonebook = {};

  @action.bound
  updatePhonebook(payload: ConfigPhonebook = {}) {
    this.phonebook = { ...this.phonebook, ...payload };
  }

  /**
   * 背景
   */
  @observable
  background: ConfigBackground = {};

  @action.bound
  updateBackground(payload: ConfigBackground = {}) {
    this.background = { ...this.background, ...payload };
  }

  /**
   * 通话
   */
  @observable
  callset: ConfigCallset = {};

  @action.bound
  updateCallset(payload: ConfigCallset = {}) {
    this.callset = { ...this.callset, ...payload };
  }

  /**
   * 屏保
   */
  @observable
  screensaver: ConfigScreensaver = {};

  @action.bound
  updateScreensaver(payload: ConfigScreensaver = {}) {
    this.screensaver = { ...this.screensaver, ...payload };
  }

  /**
   * 语言和键盘
   */
  @observable
  language: ConfigLanguge = {};

  @action.bound
  updateLanguge(payload: ConfigLanguge = {}) {
    this.language = { ...this.language, ...payload };
  }

  /**
   * 任务栏
   */
  @observable
  taskbar: ConfigTaskbar = {};

  @action.bound
  updateTaskbar(payload: ConfigTaskbar = {}) {
    this.taskbar = { ...this.taskbar, ...payload };
  }

  /**
   * 屏幕自适应
   */
  @observable
  fitscreen: ConfigFitScreen = {};

  @action.bound
  updateFitscreen(payload: ConfigFitScreen = {}) {
    this.fitscreen = { ...this.fitscreen, ...payload };
  }

  /**
   * app
   */
  @observable
  menu: ConfigMenu = {};

  @action.bound
  updateMenu(payload: ConfigMenu = {}) {
    this.menu = { ...this.menu, ...payload };
  }

  /**
   * 三方app的更新增加几个特殊的方法
   */
  @action.bound
  updateThirdAppParam(i: number, key: keyof ThirdAppInfo, value: any) {
    // @ts-ignore  how to make this correct
    this.menu.thirdApp![i]![key] = value;
  }

  /**
   * 布局
   */
  @observable
  layout: ConfigLayout = {};

  @action.bound
  updateLayout(payload: ConfigLayout = {}) {
    this.layout = { ...this.layout, ...payload };
  }

  @action.bound
  updateLayoutApp(payload: PropType<ConfigLayout, 'app'> = []) {
    this.layout.app = payload;
  }

  @action.bound
  updateLayoutWidget(payload: PropType<ConfigLayout, 'widget'> = []) {
    this.layout.widget = payload;
  }

  @action.bound
  updateLayoutSider(payload: PropType<ConfigLayout, 'sider'> = []) {
    this.layout.sider = payload;
  }

  @action.bound
  updateLayoutFolder(payload: PropType<ConfigLayout, 'folder'> = []) {
    this.layout.folder = payload;
  }

  @action.bound
  updateLayoutShortcut(payload: PropType<ConfigLayout, 'shortcut'> = []) {
    this.layout.shortcut = payload;
  }

  /**
   * desktop
   */
  @observable
  desktop: ConfigDesktop = {};

  @action.bound
  updateDesktop(payload: ConfigDesktop = {}) {
    this.desktop = { ...this.desktop, ...payload };
  }

  /**
   * 切换型号时重置
   */

  @action.bound
  initConfigParams(payload: ConfigParams) {
    this.settings = payload.settings || {};
    this.phonebook = payload.phonebook || {};
    this.background = payload.background || {};
    this.callset = payload.callset || {};
    this.screensaver = payload.screensaver || {};
    this.language = payload.language || {};
    this.taskbar = payload.taskbar || {};
    this.fitscreen = payload.fitscreen || {};
    this.menu = payload.menu || {};
    this.layout = payload.layout || {};
    this.desktop = payload.desktop || {};
  }
}

const paramsStore = new ParamsStore();

autorun(() => {
  CUR_DEFAULTS = getDefaultParams(productStore.current);
  paramsStore.initConfigParams(deepCopy(CUR_DEFAULTS));
});

export default paramsStore;
